import http, { HttpSuccessOrErrorType, ListGetRequestParams, WillStopConfig } from '../http';
import { Reseller, ResultSetHeader } from '../../models';
import { AxiosRequestConfig } from 'axios';

export default {
    /**
     * 查询单个reseller资源。
     * @param params 参数
     */
    async get_reseller_id_id(_id: string, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<Reseller | null>> {
        return await http.get(`/reseller/_id/${_id}`, {
            ...config
        })
    },

    /**
     * 修改reseller账号信息
     * @param params 参数
     */
    async patch_reseller_id_reseller(params: Reseller, config?: AxiosRequestConfig):
        Promise<HttpSuccessOrErrorType<any>> {
        const { _id, ...rest } = params;
        return await http.patch(`/reseller/_id/${_id}/reseller`, {
            ...rest
        }, config)
    },

    /**
     * 管理员上传头像。
     */
    async patch_reseller_id_avatar(_id: string, params: any, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        // $ 将图片转为2进制数据
        const formData = new FormData();
        formData.append('', params);
        return (
            await http.patch(`/reseller/_id/${_id}/avatar`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                ...config
            })
        );
    },

    /**
     * 查询头像
     * @param params 参数
     */
    async get_reseller_id_avatar(id?: string, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.get(`/reseller/_id/${id}/avatar`, {
            ...config
        })
    },

    /**
     * 修改密码
     * @param params 参数
     */
    async patch_reseller_password_current(params: { _id: string, currentPassword: string, newPassword: string }, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        return await http.patch(`/reseller/password/current`, {
            ...params
        }, {
            ...config
        })
    },

    /**
     * 密码初始化
     * @param params 参数
     */
    async post_reseller_id_password_initialize(params: { _id: string }, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<ResultSetHeader>> {
        return await http.patch(`/reseller/_id/${params._id}/password`, {
            ...params
        }, {
            ...config
        })
    },


    /**
     * 获取所有集团授权资源 所有集团 包括集团下的餐厅授权
     * @param string_id 餐厅string_id
     */
    async get_reseller_condition(params: ListGetRequestParams<Reseller>, config?: WillStopConfig): Promise<HttpSuccessOrErrorType<{
        dbResults: Reseller[],
        totalCount: Array<{
            count: number;
        }>
    }[]>> {
        return await http.get(`/reseller/condition`, {
            params: {
                ...params
            },
            ...config
        })
    },


    /**
     * 
     * @param string_id 餐厅string_id
     */
    async get_reseller(id: string, config?: WillStopConfig): Promise<HttpSuccessOrErrorType<{
        dbResults: Reseller
    }[]>> {
        return await http.get(`/reseller/_id/${id}`, {
            ...config
        })
    },


    /**
     * 批量删除
     * @param params 参数
     */
    async delete_reseller(ids: Array<string>, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete('/reseller', { data: { _id: ids }, ...config })
    },

    /**
     * 根据Reseller._id删除单个Reseller资源。
     * @param params 参数
     */
    async delete_reseller_id_id(_id: string, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete(`/reseller/${_id}`, {
            ...config
        })
    },

    /**
      * 创建单个经销商资源
      * @param params 参数
      */
    async post_reseller(params: Reseller, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.post('/reseller', { ...params }, config)
    },

    /**
     * 修改单个经销商资源。
     * @param params 参数
     */
    async patch_reseller_id_id_info(params: Reseller, config?: AxiosRequestConfig):
        Promise<HttpSuccessOrErrorType<any>> {
        const { _id, ...rest } = params;
        return await http.patch(`/reseller/_id/${_id}/info`, {
            ...rest
        }, config)
    },

    /**
     * 获取经销商图片
     * @param params 参数
     */
    async get_reseller_id_id_logo(id: string): Promise<HttpSuccessOrErrorType<string | null>> {
        return await http.get(`/reseller/_id/${id}/avatar`)
    },

    /**
    * 上传经销商logo
    */
    async patch_reseller_id_logo(_id: string, imageFile: File, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        const formData = new FormData();
        formData.append('', imageFile);
        return (
            await http.patch(`/reseller/_id/${_id}/avatar`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                ...config
            })
        );
    },
    /**
     * 根据Reseller._id删除单个Reseller资源。
     * @param params 参数
     */
    async delete_reseller_id_id_hard(_id: string, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete(`/reseller/${_id}/hard`, {
            ...config
        })
    },
    /**
     * 批量删除
     * @param params 参数
     */
    async delete_reseller_hard(ids: Array<string>, config?: AxiosRequestConfig): Promise<HttpSuccessOrErrorType<any>> {
        return await http.delete('/reseller/hard', { data: { _id: ids }, ...config })
    },

}